import { ComplexSuggestedItem } from '../../../../ui/gzComplexEnumList/types';
import { PhasrDictionaryEntry } from '../../../../types/common/phasrTypes';
import { ALLOW_ACTION, RESTRICT_ACTION } from '../../types';

export class PhasrRecommendationNameDataProvider {

  private static duplicatedEntriesCache: PhasrDictionaryEntry[] | null = null;

  /**
   *
   * @param page
   * @param limit
   * @param searchString
   */
  static getRemoteData(
    page: number,
    limit: number,
    searchString: string = '',
  ): Array<PhasrDictionaryEntry> {
    if (!this.duplicatedEntriesCache) {
      const dictionary = Application.Main.getPhasrDictionary();
      this.duplicatedEntriesCache = PhasrRecommendationNameDataProvider.generateDuplicatedEntries(dictionary);
    }

    let filteredEntries = this.duplicatedEntriesCache;

    if (searchString) {
      filteredEntries = filteredEntries.filter((item: PhasrDictionaryEntry) =>
        item.rule_recommendation.toLowerCase().includes(searchString.toLowerCase())
      );
    }

    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;

    return filteredEntries.slice(startIndex, endIndex);
  }

  static convertResponse(response: Array<PhasrDictionaryEntry>): ComplexSuggestedItem[] {
    return response.map((item: PhasrDictionaryEntry) => {
      return {
        label: item.rule_recommendation,
        value: item.ruleId,
      };
    });
  }


  /**
   * Generates duplicated entries for the dictionary.
   * @param dictionary
   * @private
   */
  private static generateDuplicatedEntries(dictionary: Record<string, any>): PhasrDictionaryEntry[] {
    const duplicatedEntries: PhasrDictionaryEntry[] = [];

    Object.entries(dictionary).forEach(([key, value]) => {
      if (typeof value === 'object' && value !== null) {
        duplicatedEntries.push({
          ...value,
          ruleId: `${key}-${ALLOW_ACTION}`,
          rule_recommendation: value.rule_allow_name,
        });

        duplicatedEntries.push({
          ...value,
          ruleId: `${key}-${RESTRICT_ACTION}`,
          rule_recommendation: value.rule_recommendation,
        });
      }
    });

    return duplicatedEntries;
  }
}
